import './messageBanner.scss';

export default function MessageBanner({
  content,
  onClose,
}) {
  return (
    <div className="message-banners">
      <div className="message-banner">
        <div>
          <div 
            className="message-banner-content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
          {onClose && (
            <button
              className="message-banner-close"
              aria-label="Close message"
              onClick={onClose}
            >
              <span className="message-banner-close-line" />
              <span className="message-banner-close-line message-banner-close-line-2" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
